import { render, staticRenderFns } from "./AddAffectedComponentModal.vue?vue&type=template&id=21f392bf&"
import script from "./AddAffectedComponentModal.vue?vue&type=script&lang=js&"
export * from "./AddAffectedComponentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f392bf')) {
      api.createRecord('21f392bf', component.options)
    } else {
      api.reload('21f392bf', component.options)
    }
    module.hot.accept("./AddAffectedComponentModal.vue?vue&type=template&id=21f392bf&", function () {
      api.rerender('21f392bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/vulnerabilities/AddAffectedComponentModal.vue"
export default component.exports